import { Box, Button, DialogActions, DialogContent, DialogTitle, Modal, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { cancelInvoice } from "../../api/invoices";

const CancelModal = ({ open, onClose, invoiceId, onErrorChange, onLoadingChange}) => {
    const [loadingCancel, setLoadingCancel] = useState(false);
    const [configCancelApiError, setConfigCancelApiError] = useState(false);

    const handleConfirmCancel = async () => {
        try {
            setLoadingCancel(true);
            onLoadingChange?.(invoiceId);
            await cancelInvoice({ invoiceId });
            onErrorChange?.(false);
            onClose()
        } catch (error) {
            setConfigCancelApiError({ errorMessage: error.message });
            onErrorChange?.(true);
            onClose()
        } finally {
            setLoadingCancel(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "100%",
                    maxWidth: "28rem",
                    outline: "none",
                }}
            >
                <Paper
                    elevation={16}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: '1rem',
                        borderRadius: '0.25rem',
                    }}
                >

                    <DialogTitle
                        sx={{
                            p: '1rem 1.5rem',
                        }}>
                        <Typography variant="h5">
                            Cancelar Fatura
                        </Typography>
                    </DialogTitle>
                    <>
                        <DialogContent sx={{ py: '1.5rem', pb: '1.25rem' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
                                <Typography variant="body1">Tem certeza que deseja cancelar essa fatura?</Typography>
                                <Typography variant="body1">Essa ação não poderá ser desfeita.</Typography>
                            </Box>
                        </DialogContent>
                    </>
                    <DialogActions sx={{ display: 'flex' }}>
                        <Button
                            sx={{ mt: 2 }}
                            variant="cancelDialog"
                            color="secondary"
                            onClick={onClose}
                        >
                            Fechar
                        </Button>
                        <Button
                            sx={{ mt: 2 }}
                            variant="redButton"
                            onClick={handleConfirmCancel}
                            loading={loadingCancel}
                            loadingPosition="start"
                        >
                            Confirmar cancelamento
                        </Button>
                    </DialogActions>
                </Paper>
            </Box>
        </Modal>
    )
};

export default CancelModal;